const PREFIX = 'gixcore:page-job-run:v1'
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000

function storage () {
  if (typeof window === 'undefined' || !window.localStorage) return null
  return window.localStorage
}

function userScope () {
  const store = storage()
  if (!store) return 'anonymous'
  try {
    const user = JSON.parse(store.getItem('user') || '{}')
    return String(user.id || user.email || 'current')
  } catch (error) {
    return 'current'
  }
}

function keyFor (pageKey, contextKey) {
  return `${PREFIX}:${userScope()}:${pageKey}:${contextKey || 'primary'}`
}

function runId (run) {
  return run && (run.id || run.runId || run.run_id)
}

function jobKey (run) {
  return run && (run.jobKey || run.job || run.key)
}

export function savePageJobRun (pageKey, contextKey, run) {
  const store = storage()
  if (!store || !run || (!runId(run) && !jobKey(run))) return null
  const record = {
    runId: runId(run) || '',
    jobKey: jobKey(run) || '',
    label: run.label || '',
    runKey: run.runKey || '',
    status: run.status || run.state || 'queued',
    startedAt: run.startedAt || run.createdAt || run.queuedAt || new Date().toISOString(),
    intent: run.intent || '',
    candidateId: run.candidateId || '',
    reopen: !!run.reopen,
    savedAt: Date.now()
  }
  try {
    store.setItem(keyFor(pageKey, contextKey), JSON.stringify(record))
  } catch (error) {
    // Storage can be unavailable in private/restricted browser contexts.
  }
  return record
}

export function loadPageJobRun (pageKey, contextKey) {
  const store = storage()
  if (!store) return null
  const key = keyFor(pageKey, contextKey)
  try {
    const record = JSON.parse(store.getItem(key) || 'null')
    if (!record || (!record.runId && !record.jobKey)) return null
    if (!record.savedAt || Date.now() - Number(record.savedAt) > MAX_AGE_MS) {
      store.removeItem(key)
      return null
    }
    return record
  } catch (error) {
    store.removeItem(key)
    return null
  }
}

export function clearPageJobRun (pageKey, contextKey) {
  const store = storage()
  if (!store) return
  try {
    store.removeItem(keyFor(pageKey, contextKey))
  } catch (error) {
    // Best-effort cleanup only.
  }
}
